import { t as i18n } from 'ttag'

export default function passwordValidation(comparator) {
  const hasNumber = new RegExp('[0-9]')
  const hasSpecialCharacter = new RegExp('[^A-Za-z0-9]')
  const hasSpace = new RegExp(' ')
  const hasLowerCaseAlphabet = new RegExp('[a-z]')
  const hasUpperCaseAlphabet = new RegExp('[A-Z]')
  const hasMinimumLengthOf = value => new RegExp(`^.{${value},}$`)
  const hasMaximumLengthOf = value => new RegExp(`^.{0,${value}}$`)

  return {
    required: i18n`Password is required.`,
    validate: {
      denySpace: value =>
        !hasSpace.test(value) || i18n`Password must not have space.`,
      hasThreeOfFour: value => {
        const validCollection = [
          hasLowerCaseAlphabet.test(value) ||
            i18n`at least one lowercase alphabet character`,
          hasUpperCaseAlphabet.test(value) ||
            i18n`at least one uppercase alphabet character`,
          hasNumber.test(value) || i18n`at least one numeric character`,
          hasSpecialCharacter.test(value) || i18n`at least one special character`
        ]
        const initialErrorMessage = 'Password must have'
        const validCount = validCollection.filter(item => item === true).length
        if (validCount < 3) {
          const errorCollection = validCollection.filter(item => item !== true)
          const errorMessage =
            validCount >= 2
              ? `${initialErrorMessage} ${errorCollection.join(i18n` or `)}.`
              : `${initialErrorMessage} ${errorCollection[0]}`
          return errorMessage
        }
      },
      hasMinimumLength: value =>
        hasMinimumLengthOf(8).test(value) ||
        i18n`Password must have minimum of 8 characters.`,
      hasMaximumLength: value =>
        hasMaximumLengthOf(32).test(value) ||
        i18n`Password must have maximum of 32 characters.`,
      confirmPassword: value =>
        !!comparator
          ? comparator !== value
            ? i18n`Passwords did not match`
            : null
          : null
    }
  }
}
